/* eslint-disable import/no-anonymous-default-export */
import React from 'react'
import { makeStyles, Typography } from '@material-ui/core'
const useStyles = makeStyles((theme) => ({
  label: {
    // color: 'white',

    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
}))

export default ({ className, label, style, onClick }) => {
  const classes = useStyles()
  const renderClass = className ? `${className} ${classes.label}` : classes.label

  return (
    <Typography className={renderClass} style={style} onClick={onClick}>
      {label}
    </Typography>
  )
}
